/*! @pentacode/ui v0.1.0 */
// ../../node_modules/.pnpm/@oddsquad+vite-plugin-lit@0.18.0_@devframes+agentic@1.1.0_@vitejs+devtools-kit@0.7.6_@d_e6e88130025ebd9690874a3125b1a4ed/node_modules/@oddsquad/vite-plugin-lit/lib/runtime/css-build.js
var e = (e, t) => {
	let n = new CSSStyleSheet();
	return n.replaceSync(e), t?.(n)(), n;
};
export { e as t };

//# sourceMappingURL=css-build-DcREbovZ.js.map